import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    SNACK_BAR_DANGER_THEME,
    SNACK_BAR_FAILURE_THEME,
    SNACK_BAR_SUCCESS_THEME
} from './TSnackbarMuiTheme';
import { withStyles } from '@material-ui/core/styles/index';
import { MuiThemeProvider } from '@material-ui/core';
import { resetSnackBar } from 'store/actions/snackBarAction';
import MuiAlert from '@material-ui/lab/Alert';

const style = (theme) => ({
    success: {
        color: 'white !important',
        paddingRight: 10
    },
    error: {
        color: 'white !important',
        backgroundColor: 'red !important'
    }
});

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const TSnackbar = (props) => {
    const { open, resetSnackBar, variant, message } = props;
    let xTheme;
    if (variant === 'success') {
        xTheme = SNACK_BAR_SUCCESS_THEME;
    } else if (variant === 'error') {
        xTheme = SNACK_BAR_DANGER_THEME;
    } else {
        xTheme = SNACK_BAR_FAILURE_THEME;
    }

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!open) {
            setShow(false);
            return undefined;
        }

        setShow(true);
        const timer = setTimeout(() => {
            setShow(false);
            resetSnackBar();
        }, 4000);

        return () => clearTimeout(timer);
    }, [open, message, resetSnackBar]);

    return (
        <MuiThemeProvider theme={xTheme}>
            <Snackbar
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                open={show}
                autoHideDuration={4000}
                onClose={resetSnackBar}
            >
                <Alert onClose={resetSnackBar} severity={variant} id="message-id">
                    {message}
                </Alert>
            </Snackbar>
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => ({
    open: state.snackBar.snackBarOptions.showSnackbar,
    variant: state.snackBar.snackBarOptions.variant,
    message: state.snackBar.snackBarOptions.message
});

TSnackbar.propTypes = {
    resetSnackBar: PropTypes.func.isRequired
};

export default connect(mapStateToProps, { resetSnackBar })(withStyles(style)(TSnackbar));
